export default __webpack_public_path__ + "static/media/waGrow.06e421a0.png";